var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.params.component)?_c(_vm.params.component,_vm._b({ref:"modal",tag:"component"},'component',_vm.params.props,false)):_vm._e(),_c('div',{ref:"container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }